import React from "react";

const TalentNotification = () => {
  return <div>TalentNotification</div>;
};

export default TalentNotification;
